import { deviceType as detectedDeviceType } from "react-device-detect";

/** Normalize react-device-detect → desktop | mobile */
export function currentDeviceKind() {
  const raw = String(detectedDeviceType || "").toLowerCase();
  if (raw === "mobile" || raw === "tablet") return "mobile";
  return "desktop";
}

/**
 * @param {"desktop"|"mobile"|"both"|string} allowedDeviceTypes
 * @param {string} [deviceKind]
 */
export function isDeviceAccessAllowed(allowedDeviceTypes, deviceKind) {
  const policy = String(allowedDeviceTypes || "both")
    .toLowerCase()
    .trim();
  const device = deviceKind || currentDeviceKind();
  if (!policy || policy === "both") return true;
  if (policy === "desktop") return device === "desktop";
  if (policy === "mobile") return device === "mobile";
  return true;
}

export function devicePolicyErrorMessage(allowedDeviceTypes) {
  const policy = String(allowedDeviceTypes || "both").toLowerCase();
  if (policy === "desktop") {
    return "Aksesi lejohet vetëm nga desktop.";
  }
  if (policy === "mobile") {
    return "Aksesi lejohet vetëm nga celular / tablet.";
  }
  return "Ky pajisje nuk lejohet për llogarinë tuaj.";
}
